import { LuCalendar, LuList, LuType, LuAlignLeft, LuHash } from 'react-icons/lu';
import type { CustomFieldType } from '../types';

/**
 * フィールドタイプに応じたアイコンを取得
 */
export function getFieldTypeIcon(fieldType: CustomFieldType): React.ReactNode {
  const iconProps = { size: 16, className: 'text-gray-600' };

  switch (fieldType) {
    case 'short_text':
      return <LuType {...iconProps} />;
    case 'long_text':
      return <LuAlignLeft {...iconProps} />;
    case 'single_select':
    case 'multiple_select':
      return <LuList {...iconProps} />;
    case 'date':
    case 'datetime':
      return <LuCalendar {...iconProps} />;
    case 'number':
      return <LuHash {...iconProps} />;
    default:
      return <LuType {...iconProps} />;
  }
}

/**
 * フィールドタイプに応じたラベルを取得
 */
export function getFieldTypeLabel(fieldType: CustomFieldType): string {
  switch (fieldType) {
    case 'short_text':
      return '1行テキスト';
    case 'long_text':
      return '複数行テキスト';
    case 'single_select':
      return '単一選択';
    case 'multiple_select':
      return '複数選択';
    case 'date':
      return '日付';
    case 'datetime':
      return '日時';
    case 'number':
      return '数値';
    default:
      return 'テキスト';
  }
}

/**
 * フィールドタイプに応じたタグの背景色を取得
 */
export function getFieldTypeTagColor(_fieldType: CustomFieldType): string {
  // すべて同じ色（Figmaデザインに準拠）
  return 'bg-gray-100';
}
